import { UpdateIcon } from '@radix-ui/react-icons';
import { useEffect, useState, } from 'react';
import { Button } from '../ui/button';
import {
    Dialog,
    DialogClose,
    DialogContent,
    DialogDescription,
    DialogHeader,
    DialogTitle,
    DialogTrigger,
} from "../ui/dialog";
import { DropdownMenuItem } from "../ui/dropdown-menu";
import { Label } from '../ui/label';

import api from '../../lib/api';
import { Input } from '../ui/input';
import { toast } from '../ui/use-toast';

function AddNewRoundDialog({ competitionClass, dropdown, onUpdateClass }) {
    const [isLoading, setIsLoading] = useState(false);
    const [isDialogOpen, setIsDialogOpen] = useState(false);
    const [criteriaValue, setCriteriaValue] = useState('');
    const [previewCount, setPreviewCount] = useState(0);
    const [passPercentage, setPassPercentage] = useState(0);
    const [oocPreview, setOocPreview] = useState(0);

    const isFirstRound = (competitionClass) => {
        // Check if there are no rounds added yet
        const existingRounds = [2, 3].filter((round) => competitionClass[`max_errors_round${round}`] !== null);

        return existingRounds.length === 0 && !competitionClass.registrations.some((registration) =>
            registration.straightCrookedResults?.some((result) => result.round === 1)
        );
    };

    // const getErrorsForLatestRound = (registration, currentRound) => {
    //     const resultsForCurrentRound = registration.straightCrookedResults?.find(
    //         (result) => result.round === currentRound
    //     );
    //     return resultsForCurrentRound ? resultsForCurrentRound.errors : null;
    // };

    // Dynamically determine if this is the first round
    const isFirstRoundFlag = isFirstRound(competitionClass);

    const resetDialogState = () => {
        setCriteriaValue('');
        setPreviewCount(0);
        setOocPreview(0);
        setIsLoading(false);
    };

    // // Calculate the percentage of bunnies that pass for height/length
    // useEffect(() => {
    //     const parsedValue = Number(criteriaValue);

    //     if (
    //         isNaN(parsedValue) ||
    //         parsedValue < 0 ||
    //         competitionClass?.registrations?.length === 0
    //     ) {
    //         setPreviewCount(0);
    //         setOocPreview(0);
    //         setPassPercentage(0); // Reset percentage
    //         return;
    //     }

    //     const existingRounds = [1, 2, 3].filter(
    //         (round) => competitionClass[`max_errors_round${round}`] !== null
    //     );
    //     const currentRound = existingRounds.length === 0
    //         ? 1
    //         : Math.max(...existingRounds);

    //     // Filter competing registrations (not crossed out and not out of competition)
    //     const validRegistrations = competitionClass.registrations.filter(
    //         (registration) => !registration.crossedOut && !registration.outOfCompetition
    //     );

    //     // Filter OOC registrations (only out of competition)
    //     const oocRegistrations = competitionClass.registrations.filter(
    //         (registration) => registration.outOfCompetition && !registration.crossedOut
    //     );

    //     // Further filter competing registrations with results for the current round
    //     const registrationsInCurrentRound = validRegistrations.filter((registration) => {
    //         const errors = getErrorsForLatestRound(registration, currentRound);
    //         return errors !== null; // Only include registrations with results for the current round
    //     });

    //     // Further filter OOC registrations with results for the current round
    //     const oocRegistrationsInCurrentRound = oocRegistrations.filter((registration) => {
    //         const errors = getErrorsForLatestRound(registration, currentRound);
    //         return errors !== null; // Only include OOC registrations with results for the current round
    //     });

    //     // Determine the registrations that pass the criteria
    //     const passedRegistrations = registrationsInCurrentRound.filter((registration) => {
    //         const errors = getErrorsForLatestRound(registration, currentRound);
    //         return errors !== null && errors <= parsedValue;
    //     });

    //     // Determine the OOC registrations that pass the criteria
    //     const passedOocRegistrations = oocRegistrationsInCurrentRound.filter((registration) => {
    //         const errors = getErrorsForLatestRound(registration, currentRound);
    //         return errors !== null && errors <= parsedValue;
    //     });

    //     const totalRegistrations = registrationsInCurrentRound.length;
    //     const passedCount = passedRegistrations.length;
    //     const oocPassedCount = passedOocRegistrations.length;

    //     // Calculate percentage for competing registrations
    //     const percentage = totalRegistrations > 0
    //         ? (passedCount / totalRegistrations) * 100
    //         : 0;

    //     // Update state
    //     setPreviewCount(passedCount); // Number of competing bunnies passing
    //     setOocPreview(oocPassedCount); // Number of OOC bunnies passing
    //     setPassPercentage(percentage.toFixed(2)); // Format percentage to 2 decimal places
    // }, [criteriaValue, competitionClass.registrations]);

    const getTotalErrors = (registration, rounds) => {
        // Summera totala fel för specificerade omgångar
        return rounds.reduce((total, round) => {
            const result = registration.straightCrookedResults?.find((r) => r.round === round);
            return total + (result ? result.errors : 0);
        }, 0);
    };

    // useEffect(() => {
    //     const parsedValue = Number(criteriaValue);

    //     if (
    //         isNaN(parsedValue) ||
    //         parsedValue < 0 ||
    //         competitionClass?.registrations?.length === 0
    //     ) {
    //         setPreviewCount(0);
    //         setOocPreview(0);
    //         setPassPercentage(0); // Reset percentage
    //         return;
    //     }

    //     const existingRounds = [1, 2, 3].filter(
    //         (round) => competitionClass[`max_errors_round${round}`] !== null
    //     );
    //     const currentRound = existingRounds.length === 0
    //         ? 1
    //         : Math.max(...existingRounds);

    //     const roundsToConsider = Array.from({ length: currentRound }, (_, i) => i + 1);

    //     // Filter competing registrations (not crossed out and not out of competition)
    //     const validRegistrations = competitionClass?.registrations?.filter(
    //         (registration) => !registration.crossedOut && !registration.outOfCompetition
    //     );

    //     // Filter OOC registrations (only out of competition)
    //     const oocRegistrations = competitionClass?.registrations?.filter(
    //         (registration) => registration.outOfCompetition && !registration.crossedOut
    //     );

    //     // Calculate total errors and determine if they pass the criteria
    //     const passedRegistrations = validRegistrations?.filter((registration) => {
    //         const totalErrors = getTotalErrors(registration, roundsToConsider);
    //         return totalErrors <= parsedValue;
    //     });

    //     const passedOocRegistrations = oocRegistrations?.filter((registration) => {
    //         const totalErrors = getTotalErrors(registration, roundsToConsider);
    //         return totalErrors <= parsedValue;
    //     });

    //     const totalRegistrations = validRegistrations?.length;
    //     const passedCount = passedRegistrations?.length;
    //     const oocPassedCount = passedOocRegistrations?.length;

    //     // Calculate percentage for competing registrations
    //     const percentage = totalRegistrations > 0
    //         ? (passedCount / totalRegistrations) * 100
    //         : 0;

    //     // Update state
    //     setPreviewCount(passedCount); // Number of competing bunnies passing
    //     setOocPreview(oocPassedCount); // Number of OOC bunnies passing
    //     setPassPercentage(percentage.toFixed(2)); // Format percentage to 2 decimal places
    // }, [criteriaValue, competitionClass.registrations]);

    // useEffect(() => {
    //     const parsedValue = Number(criteriaValue);
    //     if (isNaN(parsedValue) || parsedValue < 0) {
    //         setPreviewCount(0);
    //         setOocPreview(0);
    //         setPassPercentage(0);
    //         return;
    //     }

    //     // 1) which round am I about to add?
    //     const existing = [2, 3].filter(r =>
    //         competitionClass[`max_errors_round${r}`] != null
    //     );
    //     const nextRound = existing.length === 0
    //         ? 2
    //         : Math.max(...existing) + 1;
    //     const prevRound = nextRound - 1;

    //     // 2) split in-comp vs ooc
    //     const inComp = competitionClass.registrations
    //         .filter(r => !r.crossedOut && !r.outOfCompetition);
    //     const ooc = competitionClass.registrations
    //         .filter(r => !r.crossedOut && r.outOfCompetition);

    //     // 3) keep only those who actually ran the last full round
    //     const didPrevInComp = inComp.filter(r =>
    //         r.straightCrookedResults.some(x => x.round === prevRound)
    //     );
    //     const didPrevOoc = ooc.filter(r =>
    //         r.straightCrookedResults.some(x => x.round === prevRound)
    //     );

    //     // 4) and now apply the “sum of errors” test:
    //     const roundsToSum = Array.from({ length: prevRound }, (_, i) => i + 1);
    //     const totalErrors = (reg) => roundsToSum.reduce((s, round) => {
    //         const res = reg.straightCrookedResults.find(x => x.round === round);
    //         return res ? s + (res.errors ?? Infinity) : Infinity;
    //     }, 0);

    //     const passedInComp = didPrevInComp.filter(reg =>
    //         totalErrors(reg) <= parsedValue
    //     );
    //     const passedOoc = didPrevOoc.filter(reg =>
    //         totalErrors(reg) <= parsedValue
    //     );

    //     setPreviewCount(passedInComp.length);
    //     setOocPreview(passedOoc.length);
    //     setPassPercentage(
    //         inComp.length
    //             ? ((passedInComp.length / inComp.length) * 100).toFixed(2)
    //             : 0
    //     );
    // }, [criteriaValue, competitionClass.registrations]);

    useEffect(() => {
        // 0) no criteria typed → reset & exit
        if (criteriaValue.trim() === "") {
            setPreviewCount(0);
            setOocPreview(0);
            setPassPercentage(0);
            return;
        }

        const parsedValue = Number(criteriaValue);
        if (isNaN(parsedValue) || parsedValue < 0) {
            setPreviewCount(0);
            setOocPreview(0);
            setPassPercentage(0);
            return;
        }

        // 1) which round are we about to add?
        const existing = [2, 3].filter(r =>
            competitionClass[`max_errors_round${r}`] != null
        );
        const nextRound = existing.length === 0 ? 2 : Math.max(...existing) + 1;
        const prevRound = nextRound - 1;

        // 2) split in‑competition vs OOC
        const inComp = competitionClass.registrations.filter(r =>
            !r.crossedOut && !r.outOfCompetition
        );
        const ooc = competitionClass.registrations.filter(r =>
            !r.crossedOut && r.outOfCompetition
        );

        // 3) keep only those who actually ran the last full round
        const didPrevInComp = inComp.filter(reg => {
            const results = reg.straightCrookedResults || [];
            return results.some(x => x.round === prevRound);
        });
        const didPrevOoc = ooc.filter(reg => {
            const results = reg.straightCrookedResults || [];
            return results.some(x => x.round === prevRound);
        });

        // 4) sum up errors in rounds 1…prevRound
        const roundsToSum = Array.from({ length: prevRound }, (_, i) => i + 1);
        const totalErrors = (reg) => {
            const results = reg.straightCrookedResults || [];
            return roundsToSum.reduce((s, round) => {
                const r = results.find(x => x.round === round);
                return s + (r?.errors ?? Infinity);
            }, 0);
        };

        // 5) filter by fault threshold
        const passedInComp = didPrevInComp.filter(reg =>
            totalErrors(reg) <= parsedValue
        );
        const passedOoc = didPrevOoc.filter(reg =>
            totalErrors(reg) <= parsedValue
        );

        setPreviewCount(passedInComp.length);
        setOocPreview(passedOoc.length);
        setPassPercentage(
            inComp.length
                ? ((passedInComp.length / inComp.length) * 100).toFixed(2)
                : 0
        );
    }, [criteriaValue, competitionClass.registrations]);

    const addRound = async () => {
        setIsLoading(true);
        if (isFirstRoundFlag) {
            try {
                // Add the first round
                const updatedClass = {
                    ...competitionClass,
                    firstRoundAdded: true, // Custom flag to track explicitly added first round
                };

                await onUpdateClass(updatedClass);
                toast({
                    variant: 'success',
                    title: `Omgång 1 tillagd!`,
                    description: `Första omgången har lagts till med alla deltagare.`,
                });

                setIsDialogOpen(false);
                resetDialogState();
            } catch (error) {
                console.error("Error adding first round:", error);
                toast({
                    variant: 'destructive',
                    title: 'Något gick fel.',
                    description: error.response?.data?.error || '',
                });
            } finally {
                setIsLoading(false);
            }
            return;
        }

        // Validate criteriaValue for subsequent rounds
        const parsedValue = Number(criteriaValue);
        if (isNaN(parsedValue) || parsedValue < 0) {
            toast({
                variant: 'destructive',
                title: 'Ogiltigt värde.',
                description: 'Ange ett giltigt tal för kriterierna större än eller lika med 0.',
            });
            setIsLoading(false);
            return;
        }

        try {
            // Determine the existing rounds
            const existingRounds = [2, 3].filter((round) => competitionClass[`max_errors_round${round}`] !== null);
            const nextRound = Math.max(...existingRounds, 1) + 1;

            await api.post(`https://skhrf-api.cmdigital.se/v1/judges/submit-max-errors`, {
                classId: competitionClass.id,
                round: nextRound,
                errors: parsedValue,
            })

            if (nextRound > 3) {
                toast({
                    variant: 'destructive',
                    title: 'Maximalt antal omgångar nått.',
                    description: 'Du kan inte lägga till fler omgångar.',
                });
                return;
            }
            // Update the competition class with the new round
            const updatedClass = {
                ...competitionClass,
                [`max_errors_round${nextRound}`]: parsedValue,
            };

            await onUpdateClass(updatedClass);

            toast({
                variant: 'success',
                title: `Omgång ${nextRound} tillagd!`,
                description: `Max fel för omgång ${nextRound} är ${parsedValue}.`,
            });

            setIsDialogOpen(false);
            resetDialogState();
        } catch (error) {
            console.error("Error adding round:", error);
            toast({
                variant: 'destructive',
                title: 'Något gick fel.',
                description: error.response?.data?.error || 'Ett fel inträffade.',
            });
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <Dialog open={isDialogOpen} onOpenChange={(isOpen) => {
            setIsDialogOpen(isOpen);
            if (!isOpen) {
                resetDialogState();
            }
        }}>
            {dropdown ? (
                <DropdownMenuItem onSelect={(event) => event.preventDefault()}>
                    <DialogTrigger className='flex items-center w-full'>
                        Lägg till omgång
                    </DialogTrigger>
                </DropdownMenuItem>
            ) : (
                <DialogTrigger className='inline-flex items-center justify-center whitespace-nowrap rounded-sm px-3 py-1.5 text-sm font-medium ring-offset-background transition-all focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 disabled:pointer-events-none disabled:opacity-50 data-[state=active]:bg-background data-[state=active]:text-foreground data-[state=active]:shadow-sm'>
                    Lägg till omgång
                </DialogTrigger>
            )}
            <DialogContent className="flex flex-col gap-6">
                <DialogHeader className='text-left'>
                    <DialogTitle>
                        {isFirstRoundFlag ? 'Bekräfta första omgången' : 'Lägg till omgång'}
                    </DialogTitle>
                    <DialogDescription>
                        {isFirstRoundFlag
                            ? 'Är du säker på att du vill lägga till alla deltagare i första omgången?'
                            : 'Ange antal fel för att välja kaniner till nästa omgång.'
                        }
                    </DialogDescription>
                </DialogHeader>
                {!isFirstRoundFlag && (
                    <>
                        <div className='grid gap-2'>
                            <Label htmlFor="criteriaValue">Antal fel</Label>
                            <Input
                                min="0"
                                id="criteriaValue"
                                type="number"
                                placeholder='3'
                                onChange={(e) => setCriteriaValue(e.target.value)}
                                value={criteriaValue}
                            />
                        </div>
                        <div>
                            <p>Antal kaniner som går vidare: <span className='font-medium'>{previewCount}</span> st</p>
                            <p>Antal kaniner utom tävlan som går vidare <span className='font-medium'>{oocPreview}</span> st</p>
                            <p>Procentandel kaniner som går vidare: <span className='font-medium'>{passPercentage}</span> %</p>
                            <p className='pt-1 text-sm text-muted-foreground'>Notera att procentandelen som visas är baserad på samtliga kaniner i klassen som är i tävlan.</p>
                        </div>
                    </>
                )}
                <div className='grid grid-cols-2 gap-3'>
                    <DialogClose asChild>
                        <Button type='button' variant='secondary'>Avbryt</Button>
                    </DialogClose>
                    <Button
                        onClick={addRound}
                        disabled={isLoading || (!isFirstRoundFlag && criteriaValue.length === 0)}>
                        {(isLoading) ? <UpdateIcon className='loader-spinner' /> : <>Lägg till</>}
                    </Button>
                </div>
            </DialogContent>
        </Dialog>
    );
}

export default AddNewRoundDialog;
